import Signal from 'libs/signals';

const userSignal = Signal({
  isSignedIn: null,
});

export default userSignal;
